<template>
  <MTableCell class="m-table-cell__icon-hint">
    <MHint
      v-if="hint"
      :reference-selector="`#${id}`"
      :visible-arrow="false"
      :popper-options="{modifiers: {
        preventOverflow: {
          enabled: true
        }
      }}"
    >
      <MIcon
        :id="id"
        :icon="icon"
      />
      <template slot="content">
        {{ hint }}
      </template>
    </MHint>
  </MTableCell>
</template>

<script>
  import MIcon from 'components/Design/MIcon';
  import MHint from 'components/Help/MHint';
  import MTableCell from 'components/Data/Tables/MTable/cells/MTableCell';

  export default {
    name: 'MTableCellIconHint',
    components: {MTableCell, MIcon, MHint},
    props: {
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      }
    },
    computed: {
      id () {
        return `m-table-cell-icon-${Date.now()}`;
      },
      icon () {
        return this.tableRow[this.itemKey] ? this.tableRow[this.itemKey].icon : null;
      },
      hint () {
        return this.tableRow[this.itemKey] ? this.tableRow[this.itemKey].text : null;
      }
    }
  };
</script>

<style>
  .m-table-cell__icon-hint svg {
    width: 18px;
    height: 18px;
  }
</style>
